import React, { useEffect, useState } from "react";
import styled from "styled-components"
import { URL_Dev } from "../Variables";
import { fetchWpCached } from "../../../api/wpClient";
import SeoHead from "../../Seo/SeoHead";
import Pages from "../../../Model/Pages";
import { Title, Breadcrumb } from "../../../css/commun";
import { Link } from 'react-router-dom';
import { withTranslation } from "react-i18next";
import './Cm.css'
import ReactGA from "react-ga";
import cookies from "js-cookie";
import img from '../../../photos/consulting/Group 38868.png'

import {actions , servicesCm} from "../../Data"
import consulting from "../../../photos/consulting.svg"
import prestation from "../../../photos/sous-traitance.svg"
import MyButton from "./MyButton";


const Cm = (props) => {
  const title = props.location.pathname
  const splitState = title.split('/')
  const { t } = props
  const staticTitles = {
    en: "Social Media",
    fr: "Social Media"
  };
  const [pages, setPages] = useState([]);
  const [showAll, setShowAll] = useState(false);
  const [isSmallScreen, setIsSmallScreen] = useState(false);
  const [langue, setLangue] = useState("fr");
  const [presence, setPresence] = useState(300);
  const [active, setActive] = useState(1)
  const [visibilite, setVisibilite] = useState(580);
  const [performance, setPerformance] = useState(1190)


  const currentLanguage = cookies.get('i18next') || 'fr'
  const [titre, setTitre] = useState(staticTitles[currentLanguage]);
  const [lastChecked, setLastChecked] = useState(null);


  useEffect(() => {
    const handleResize = () => {
      const isSmall = window.matchMedia("(max-width: 575px)").matches;
      setIsSmallScreen(isSmall);
      if (isSmall) {
        setShowAll(false); 
      } else {
        setShowAll(true); 
      }
    };
    window.addEventListener("resize", handleResize);
    handleResize(); 

    return () => window.removeEventListener("resize", handleResize);
  }, []);

 
 
  const visibleActions = showAll ? actions : actions.slice(0, 5);

  useEffect(() => {
    setLangue(currentLanguage)
    document.body.dir = currentLanguage === 'ar' ? 'rtl' : 'ltr'
  }, [currentLanguage])

  const cacheTitle = (result) => {
    const page = result.find(element =>
      decodeURI(element.slug) === (splitState[1].length === 2 ? splitState[2] : splitState[1])
    );

    if (page) {
      const title = page.title.rendered.replace("&#8217;", "'");
      if (title !== titre) {
        setTitre(title);
      }
      setLastChecked(new Date().getTime()); 
    }
  };

  useEffect(() => {
    ReactGA.pageview(window.location.pathname);

    const oneMonth = 30 * 24 * 60 * 60 * 1000;
    const lastCheckedTimestamp = lastChecked || 0;

    if (new Date().getTime() - lastCheckedTimestamp >= oneMonth) {
      fetchWpCached("pages", { onRevalidated: (result) => { setPages(result); cacheTitle(result); } })
        .then((result) => {
          setPages(result);
          cacheTitle(result);
        });
    }
  }, [lastChecked]);

  let page = []
  pages.map(element =>
    decodeURI(element.slug) === (splitState[1].length === 2 ? splitState[2] : splitState[1]) &&
    page.push(new Pages(element.id, element.title.rendered, element.content.rendered, element.parent, element.slug, element.yoast_head_json.description,element.yoast_head_json.title, element.date, element.excerpt.rendered)))

  return (<>
    <SeoHead
      title={page[0]?.metatitle || titre}
      description={page[0]?.description}
      pathname={props.location.pathname}
      image={`${URL_Dev}/images/oxton.png`}
    />
    <div className="container" >
      <Breadcrumb>
        <p>
          <Link className="retour" to="/">{t('Home_link')}</Link> / <span>{titre}</span>
        </p>
      </Breadcrumb>
      <Title>
        <h1>{titre}</h1>
        <p className="title-p">En pleine ère numérique, l'art du Community management est devenu un pilier indispensable pour toute entreprise cherchant à prospérer en ligne. Chez Oxton Digital, nous comprenons l'impact puissant d'une gestion de communauté efficace et personnalisée. Notre expertise en SEO et Community management transforme votre présence en ligne en un espace dynamique et engageant, où chaque interaction compte. Nous vous accompagnons pour créer des liens durables avec votre audience, renforcer votre marque et stimuler votre croissance professionnelle. Avec Oxton Digital, transformez vos followers en véritables ambassadeurs de votre marque.</p>
      </Title>
      <div className="Equipe-cm-container">
        <div className="respect-container">
          <div className="respect-icon">
            <img src={img} alt="Réactivité" />
          </div>
          <div className="respect-content">
            <h3>Notre équipe élabore, anime et modère pour vous les réseaux sociaux de votre marque</h3>
            <p className="title-p">Pour accroître votre visibilité et votre notoriété. Choisissez l’offre qui vous convient le mieux et contactez un membre de notre équipe pour démarrer simplement et rapidement. Un community manager prendra alors contact avec vous pour identifier vos besoins, fixer vos objectifs et établir les leviers adéquats de votre stratégie social media.</p>
          </div>
        </div>
        <div className="services-section-media">
          {servicesCm.map((service) => (
            <div key={service.id} className="service-card-media">
              <img src={service.icon} alt={`Icon ${service.id}`} className="service-media-icon" />
              <h3>{service.title}</h3>
              <ul>
                {service.points.map((point, index) => (
                  <li key={index}>{point}</li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
      <div className="why-manager">
        <div className="respect-container">
          <div className="respect-icon">
            <img src={img} alt="Réactivité" />
          </div>
          <div className="respect-content">
            <h3>Pourquoi travailler avec un community manager?</h3>
            <ul>
              <li><p className="title-p">Parce qu’une présence active sur les réseaux sociaux est essentielle pour bâtir une image forte et crédible.</p></li>
              <li><p className="title-p">Parce que les réseaux sont une plateforme puissante pour accroître votre visibilité et dialoguer directement avec vos clients.</p></li>
              <li><p className="title-p">Parce que chaque interaction est une chance unique de créer de la valeur, fidéliser votre audience, et ajuster vos offres aux attentes réelles de vos clients.</p></li>
            </ul>
            <p className="why-p">Il existe de nombreuses astuces pour être visible sur internet et nous vous orienterons sur celles qui seront les plus adaptées à votre marque:</p>

          </div>
        </div>
        <div className="social-media-actions">
          {visibleActions.map((action) => (
            <div key={action.id} className="action-card">
              <img src={action.icon} />
              <p>{action.text}</p>
            </div>
          ))}
        </div>
        {isSmallScreen && actions.length > 5 && (
          <button
            className="show-more-btn"
            onClick={() => setShowAll((prev) => !prev)}
          >
            {showAll ? "Voir moins" : "Voir plus"}
          </button>
        )}

      </div>
      <div className="other-services-media-page">
        <div className="respect-container">
          <div className="respect-content">
            <h3>Autres services</h3>
          </div>
        </div>
        <div className="other-cards-media-page">

          <a href="/fr/service-de-consultation" className="other-card-media">
            <img src={consulting} alt="consulting-icon" />
            <h3>Consulting</h3>
            <p className="title-p">
              Besoin de conseils pointus et avisés sur votre business digital ? Nos experts en consulting vous répondent.
            </p>
          </a>

          <a href="/fr/prestation-de-service" className="other-card-media">
            <img src={prestation} alt="prestation-icon" />
            <h3>Sous traitance</h3>
            <p className="title-p">Vous avez des besoins techniques, de développement ou digitaux? Vous êtes au bon endroit!</p>
          </a>
        </div>
      
            <StratégieSocialMedia id='section'>
        <h2 className={langue === "ar" && "alignRightMobile"}>{t('Strategy')} {t('social media')}</h2>
        <p className="title-p">{t('Cm.Opt for one of the packages')}</p>

        <div className="ListButton">
          <button className={active === 1 ? "btn btn-light active" : "btn btn-light"} onClick={() => { setActive(1); setPresence(300); setVisibilite(580); setPerformance(1190) }}>{t('WITHOUT COMMITMENT')}</button>
          <button className={active === 2 ? "btn btn-light active" : "btn btn-light"} onClick={() => { setActive(2); setPresence(260); setVisibilite(540); setPerformance(1099) }}>{t('SUBSCRIPTION')} 6 {t('MONTH')}</button>
          <button className={active === 3 ? "btn btn-light active" : "btn btn-light"} onClick={() => { setActive(3); setPresence(230); setVisibilite(499); setPerformance(999) }}>{t('SUBSCRIPTION')} 12 {t('MONTH')}</button>
        </div>

        <div className="row gy-3">
          <div className="col-md-4">
            <div className="card">
              <ul className={langue === "ar" && "ul-ar"}>
                <div>
                  <span className="euroextendedbold">{t('Presence Pack')}</span><br />
                  <span className="number"> {presence} <sup>€</sup></span> / {t('Month')}
                </div>
                <li><h3>{t('Starting')}</h3></li>
                <li><img src="/images/seo/7-Check.svg" alt="Check" /><span>{t('Kick-off_meeting')}</span></li>
                <li><img src="/images/seo/7-Check.svg" alt="Check" /><span>{t('Cm.Definition of objectives')}</span></li>
                <li><img src="/images/seo/7-Check.svg" alt="Check" /><span>{t('Cm.Update of the page')}</span></li>
                <hr />
                <li><h3>{t('Strategy')}</h3></li>
                <li><img src="/images/seo/7-Check.svg" alt="Check" /><span>{t('Cm.Shared working document')}</span></li>
                <li><img src="/images/seo/7-Check.svg" alt="Check" /><span>{t('Cm.Quarterly strategic review')}</span></li>
                <hr />
                <li><h3>{t('Social media')}</h3></li>
                <li>{t('Publication on')} 1 {t('social media')}</li>
                <li>1 {t('publication per week')}</li>
                <li><img src="/images/seo/7-Check.svg" alt="Check" /><span>{t('Cm.Content writing')}</span></li>
                <li><img src="/images/seo/7-Check.svg" alt="Check" /><span>{t('Cm.Creation of visuals')}</span></li>
                <li><img src="/images/seo/7-Check.svg" alt="Check" /><span>{t('Cm.Photos with rights of use')}</span></li>
                <li><img src="/images/seo/7-Check.svg" alt="Check" /><span>{t('Cm.Choice of hashtags')}</span></li>
                <li><img src="/images/seo/7-Check.svg" alt="Check" /><span>{t('Cm.Integration of publications')}</span></li>
                <li><img src="/images/seo/7-Check.svg" alt="Check" /><span>{t('Cm.Programming & publishing')}</span></li>
              </ul>
              <div>
                <p>{t('Set_up')}<span>300 €</span></p>
                 {/* <button className="btn button"><span className="pseudo-text">En Profitez</span></button>  */}
              </div>
            </div>
          </div>

          <div className="col-md-4">
            <div className="card">
              <ul className={langue === "ar" && "ul-ar"}>
                <div>
                  <span className="euroextendedbold">{t('Visibility Pack')}</span><br />
                  <span className="number"> {visibilite} <sup>€</sup></span> / {t('Month')}
                </div>
                <li><h3>{t('Starting')}</h3></li>
                <li><img src="/images/seo/7-Check.svg" alt="Check" /><span>{t('Kick-off_meeting')}</span></li>
                <li><img src="/images/seo/7-Check.svg" alt="Check" /><span>{t('Cm.Definition of objectives')}</span></li>
                <li><img src="/images/seo/7-Check.svg" alt="Check" /><span>{t('Cm.Update of the page')}</span></li>
                <hr />
                <li><h3>{t('Strategy')}</h3></li>
                <li><img src="/images/seo/7-Check.svg" alt="Check" /><span>{t('Cm.Shared working document')}</span></li>
                <li><img src="/images/seo/7-Check.svg" alt="Check" /><span>{t('Cm.Quarterly strategic review')}</span></li>
                <hr />
                <li><h3>{t('Social media')}</h3> </li>
                <li>{t('Publication on')} 2 {t('social media')}</li>
                <li>2 {t('publication per week')}</li>
                <li><img src="/images/seo/7-Check.svg" alt="Check" /><span>{t('Cm.Content writing')}</span></li>
                <li><img src="/images/seo/7-Check.svg" alt="Check" /><span>{t('Cm.Creation of visuals')}</span></li>
                <li><img src="/images/seo/7-Check.svg" alt="Check" /><span>{t('Cm.Photos with rights of use')}</span></li>
                <li><img src="/images/seo/7-Check.svg" alt="Check" /><span>{t('Cm.Choice of hashtags')}</span></li>
                <li><img src="/images/seo/7-Check.svg" alt="Check" /><span>{t('Cm.Integration of publications')}</span></li>
                <li><img src="/images/seo/7-Check.svg" alt="Check" /><span>{t('Cm.Programming & publishing')}</span></li>
                <li><img src="/images/seo/7-Check.svg" alt="Check" /><span>{t('Cm.Organization of a contest')}</span></li>
                <li><img src="/images/seo/7-Check.svg" alt="Check" /><span>{t('Cm.Animation and moderation')} 4{t('h')}/{t('Month')}</span></li>
              </ul>
              <div>
                <p>{t('Set_up')}<span>300 €</span></p>
                 {/* <button className="btn button"><span className="pseudo-text">En Profitez</span></button>  */}
              </div>
            </div>
          </div>
          <div className="col-md-4">
            <div className="card">
              <ul className={langue === "ar" && "ul-ar"}>
                <div>
                  <span className="euroextendedbold">{t('Performance Pack')}</span><br />
                  <span className="number"> {performance} <sup>€</sup></span> / {t('Month')}
                </div>
                <li><h3>{t('Starting')}</h3></li>
                <li><img src="/images/seo/7-Check.svg" alt="Check" /><span>{t('Kick-off_meeting')}</span></li>
                <li><img src="/images/seo/7-Check.svg" alt="Check" /><span>{t('Cm.Definition of objectives')}</span></li>
                <li><img src="/images/seo/7-Check.svg" alt="Check" /><span>{t('Cm.Update of the page')}</span></li>
                <hr />
                <li><h3>{t('Strategy')}</h3></li>
                <li><img src="/images/seo/7-Check.svg" alt="Check" /><span>{t('Cm.Shared working document')}</span></li>
                <li><img src="/images/seo/7-Check.svg" alt="Check" /><span>{t('Cm.Quarterly strategic review')}</span></li>
                <hr />
                <li><h3>{t('Social media')}</h3> </li>
                <li>{t('Publication on')} 4 {t('social media')}</li>
                <li>4 {t('publication per week')}</li>
                <li><img src="/images/seo/7-Check.svg" alt="Check" /><span>{t('Cm.Content writing')}</span></li>
                <li><img src="/images/seo/7-Check.svg" alt="Check" /><span>{t('Cm.Creation of visuals')}</span></li>
                <li><img src="/images/seo/7-Check.svg" alt="Check" /><span>{t('Cm.Photos with rights of use')}</span></li>
                <li><img src="/images/seo/7-Check.svg" alt="Check" /><span>{t('Cm.Choice of hashtags')}</span></li>
                <li><img src="/images/seo/7-Check.svg" alt="Check" /><span>{t('Cm.Integration of publications')}</span></li>
                <li><img src="/images/seo/7-Check.svg" alt="Check" /><span>{t('Cm.Programming & publishing')}</span></li>
                <li><img src="/images/seo/7-Check.svg" alt="Check" /><span>{t('Cm.Organization of a contest')}</span></li>
                <li><img src="/images/seo/7-Check.svg" alt="Check" /><span>{t('Cm.Animation and moderation')} 6{t('h')}/{t('Month')}</span></li>
              </ul>
              <div>
                <p>{t('Set_up')}<span>300 €</span></p>
              </div>
            </div>
          </div>
        </div>
      </StratégieSocialMedia> 
      <div className="meet-rec-cm">
          <div className="respect-container">
            <div className="respect-content">
              <h3>Vous êtes prêt à lancer votre campagne web marketing?</h3>
            </div>
          </div>
          <div className="detail-meet-rec">
            <div className="meet-rec-title-btn">
              <p className="title-p">Contactez-nous dès aujourd’hui pour une consultation gratuite et découvrez comment nous pouvons vous aider à atteindre vos objectifs !</p>
              <MyButton />
            </div>
          </div>
        </div>
      </div>
    
    </div>
  </>)
}


const StratégieSocialMedia = styled.div`
  margin-top: 70px;
  @media (max-width: 991px) {
   margin-top: 50px;
  }
  @media (max-width: 767px) {
   margin-top: 45px;
  }
   @media (max-width: 575px) {
      margin-top: 35px;
   }
  >h2{

    padding-bottom: 10px;
  }

  >p{

    padding-bottom: 20px;
  }

  >.ListButton{
    background-color: #20ACE3;
    margin-bottom: 40px ;
    border-radius: 6px;
    @media (max-width: 577px) {
      display: flex;
      flex-direction: column;
    }
    >.btn-light{
      width: 33.33%;
      color: white;
      background-color: transparent;
      border: 0;
      @media (max-width: 577px) {
      width: 100%;
      }
    }
    >.active{
      background-color: white;
      color: #20ACE3;
      border: 4px solid #20ACE3;
    }
    >.btn-light.active:focus{
      box-shadow: none;
    }
    >.btn-light:focus-visible{
      outline: none;
      border: transparent;
    }
    >.btn-light:focus{
      box-shadow: none;
      border: 4px solid #20ACE3;
    }
    .btn-light:active{
      border: 4px solid #20ACE3;
    }

  }

  >.row {
    justify-content: center;
    .col-md-4 {
      @media (max-width: 1051px) {
      width: 50%;
    }
    @media (max-width: 663px) {
      width: 100%;
    }
    justify-content: center;
    
    .card{
      box-shadow: 0px 0px 6px rgba(32, 172, 227, .16);
      padding: 30px;
      height: 100%;
      border-radius: 15px;
      >ul{
        list-style: none;
        padding-left: 0;
        >li{
          line-height: 28px;
    font-size: 14px;
    gap: 12px;
    display: flex;
          >h3{
           font-family: RalewayRegular;
    font-weight: 600;
    margin-bottom: 0px;
    line-height: 28px !important;
    font-size: 14px !important;
          }
          >.blue{
            color :#20ACE3;
          }
          >img{
            padding-right: 8px ;
          }
        }
        >div{
          background-color: #EEF7FB;
          padding-top: 20px;
          margin-bottom: 20px;
          border-radius: 15px;
          font-weight: 600;
          color :#20ACE3;
          text-align: center;
          >.euroextendedbold{
            color: #17406F;
            font-family: 'RalewayRegular';
          }
          .number{
            font-size: 42px;
            font-family: 'RalewayRegular';
            >sup{
              font-size: 16px;
              position: relative;
              top: -25px;
              margin-left: -12px;
            }
          }
        }
      }
      >.ul-ar{
        padding-right: 0;
      }
      >ul >li >img{
        padding-right: 0;
        padding-left: 8px;
      }
      >div{
        display: flex;
        flex-direction: column;
        align-items: center;
        place-content: flex-end;
        height: 100%;

        >p{
        padding: 12px 19px;
    text-align: center;
    border-radius: 6px;
    color: rgb(23, 64, 111);
    display: flex;
    flex-flow: wrap;
    -webkit-box-pack: justify;
    justify-content: space-between;
    width: 100%;
    gap: 5px;
    background-color: rgb(238, 247, 251);
    font-weight: bold;
    font-family: RalewayRegular;
    margin-bottom: 0px;
        
        } 
        >.button{
          padding: 10px 20px !important;
          color: white;
          width: 150px;
          border-radius:10px !important;
        }
      }
    }
  }
}
`;

export default withTranslation()(Cm)
